import { ReactNode } from "react";

import * as theme from "./ApplicationBarHeaderRow.css";
import { useApplicationBarVariant } from "./ApplicationBarVariant";

export interface ApplicationBarHeaderRowProps {
    /**
     * The `Breadcrumbs`, then the `ApplicationBarProfile`.
     */
    children: ReactNode;
}

export function ApplicationBarHeaderRow({
    children,
}: ApplicationBarHeaderRowProps) {
    const variant = useApplicationBarVariant();

    return <div className={theme.row[variant]}>{children}</div>;
}
